import React, { FC } from 'react';

import Typography from '@mui/material/Typography';

import { modalActions } from '@contexts/common/ModalContext';

import Button from '@components/common/Button';
import ModalWrapper from '@components/common/Modal/ModalWrapper';

import { Variant } from '@constants/common/ui.constants';

import { PriceImpactModalProps } from '@app-types/common/modal.types';

import useStyles from './styles.module';

const PriceImpactModal: FC<PriceImpactModalProps> = ({ onConfirm }) => {
  const { classes } = useStyles();

  return (
    <ModalWrapper title="Confirm the action">
      <div className={classes.wrap}>
        <Typography variant="body1" color={(theme) => theme.accent.a6}>
          The price impact is to high. Are you sure you want to proceed?
        </Typography>
        <div className={classes.row}>
          <Button
            fullWidth
            variant={Variant.Secondary}
            onClick={modalActions.hide}
          >
            Cancel
          </Button>
          <Button fullWidth variant={Variant.Error} onClick={onConfirm}>
            Proceed
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default PriceImpactModal;
